import { render, staticRenderFns } from "./monitoring.vue?vue&type=template&id=c81acea2&scoped=true"
import script from "./monitoring.vue?vue&type=script&lang=js"
export * from "./monitoring.vue?vue&type=script&lang=js"
import style0 from "./monitoring.vue?vue&type=style&index=0&id=c81acea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81acea2",
  null
  
)

export default component.exports